import { AbstractCRUDService } from './AbstractCRUDService';
import { INewScan, Scan, IUpdateScan } from '../models/Scan';
import * as assert from 'assert';

export class ScanService extends AbstractCRUDService<Scan, INewScan, IUpdateScan> {
    protected basePath: string = 'scan';

    public requestHelp(scan_id: number, topic: string): Promise<void> {
        return this.postSubPath(`${scan_id}/help`, { topic });
    }

    protected assembleInstances(response: any[]): Scan[] {
        assert(Array.isArray(response), 'ScanService#assembleInstances passed invalid response data');

        const out: Scan[] = [];

        response.forEach((rawDay) => {
            out.push(new Scan(rawDay));
        });

        return out;
    }

    protected assembleSingleInstance(response: any): Scan {
        return new Scan(response);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data_layer/services/ScanService.ts